<input ngbDatepicker hidden #d="ngbDatepicker" [(ngModel)]="date" (dateSelect)="onDateSelect($event)">